<script>
import BaseError from '@/objects/Exceptions/BaseError'

export default {
  name: 'ErrorWrapper',
  errorCaptured (error) {
    if (error instanceof BaseError) {
      this.$notify({
        group: 'app',
        type: error.getType(),
        title: error.getTitle(),
        text: error.getMessage(),
        closeOnClick: true,
        duration: -1
      })
      return false
    }
    console.error('Unhandled error: ', error)
  },
  render () {
    return this.$scopedSlots.default()
  }
}
</script>

<docs>

    ```jsx
    import HttpUnAuthenticatedError from '@/objects/Exceptions/HttpUnAuthenticatedError'
    import NotificationWrapper from '@/components/notification-wrapper/NotificationWrapper'
    function throwError () {
        throw new HttpUnAuthenticatedError('This is the error message')
    }
        <ErrorWrapper>
            <div>
                <Button @click.native="throwError" text="Trigger Error"></Button>
                <notification-wrapper />
            </div>
        </ErrorWrapper>
    ```
</docs>

<style lang="scss">
.vue-notification-group {
  position: fixed;
  bottom: $page-footer-height;
  top: unset !important;
  padding: 10px;
  width: 100%;
  .vue-notification-wrapper > div {
    font-size: rem(12);
    position: relative;
    margin: 0 0 5px;
    padding: 2rem 1rem 1.5rem;
    color: color(dark);
    background: color(light);
    border-left: 5px solid #187FE7;
    span:first-of-type {
      font-weight: 500;
    }
    .text-light {
      margin-top: 1rem;
    }
    svg {
      width: 1.75rem;
      height: 1.75rem;
      position: absolute;
      padding: 1rem 1rem 0 0;
      top: 0;
      right: 0;
    }
    &.border-warn {
      border-left-color: #f48a06;
    }

    &.border-error {
      border-left-color: #B82E24;
    }

    &.border-success {
      border-left-color: #42A85F;
    }
  }
}
</style>
